// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oUchs","top":"styles_top__ln-cx","left":"styles_left__1SyEt","description":"styles_description__24Zig"};